module.exports = __webpack_public_path__ + "img/vol02_cup01_label02.ad382075.png";